// src/Config.js

const API_BASE_URL = "https://gxpos.globalsi.com.py"; // Cambia esto si desplegas el backend
//https://backpdv.litchdev.com";
//const API_BASE_URL = "https://backpdv.litchdev.com";

export default API_BASE_URL;
